<template>
    <div class="wrapper">
        <div class="columns is-12-mobile">
            <div
                class="column is-12-mobile">
                <h1 class="is-size-4 has-text-weight-bold m-b-40">Lost Password</h1>
                <b-message v-if="message==true" type="is-success" aria-close-label="Close message">
                    <p>We have emailed {{nameShown.toLowerCase()}}.</p>
                    <p>On the email, please select <strong>Reset Password!</strong></p>
                    <hr>
                    <p><small>You should receive our email shortly. If not;</small></p>
                    <ul>
                        <li><small>Check your email address above is correct. If not, please <a href="/lostpassword">amend</a> it</small></li>
                        <li><small>Please check your Junk email folder</small></li>
                        <li><small>Please <a href="/contact">contact us</a> or email <a
                            href="mailto:support@pickafund.com" target="_blank">support@pickafund.com</a></small></li>
                    </ul>
                </b-message>
                <div class="info-lostpw" v-if="message!==true">
                    <p class="m-b-10">Please enter the email address used to set up your account.</p>
                    <p class="m-b-40">We will send you an email to reset your password.</p>
                    <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">

                                <ValidationProvider rules="required|email" v-slot="{ errors,valid }">
                                    <b-field
                                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                        :message="errors"
                                    >

                                        <b-input placeholder="Email"
                                                size="is-medium"
                                                v-model="form.email"
                                                icon="account"
                                                type="email"
                                                novalidate
                                                autocapitalize="off">
                                        </b-input>
                                    </b-field>
                                </ValidationProvider>
                        <div v-if="message===false" class="columns p-t-30 ">
                            <div class="column is-12 is-12-desktop">
                                <b-button @click="submit" type="is-primary">Send</b-button>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>


            </div>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>


import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';
import axios from "axios";


setInteractionMode('eager')

export default {
    name: 'SignUp1',
    components: {
        ValidationProvider,
        ValidationObserver
    },
    props: {},
    data() {
        return {
            form: {
                email: "",
            },
            message:false
        }
    },
    methods: {
        async submit() {
            this.$refs.observer.validate().then(async success => {
                if (!success) return
                axios.get('/sanctum/csrf-cookie').then(() => {
                    axios.post("/api/lost-pw", this.form)
                        .then(() => {
                                this.nameShown = this.form.email
                                this.message = true
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                        )
                        .catch((error) => {
                             this.$toast.error(error.response.data.error)
                            }
                        )
                });
            })
        }
    },
    metaInfo() {
        return {
            title: "Lost Password",
            meta: [
                { name: 'description', content:  'Testing 123'},
                /*{ property: 'og:title', content: "Epiloge - Build your network in your field of interest"},
                */
            ]
        }
    }
}

</script>


